import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2, XCircle, Info } from "lucide-react";

const config = {
  success: {
    ring: "text-emerald-300",
    dot: "bg-emerald-400",
    Icon: CheckCircle2,
  },
  error: {
    ring: "text-rose-300",
    dot: "bg-rose-400",
    Icon: XCircle,
  },
  info: {
    ring: "text-accent-300",
    dot: "bg-accent-400",
    Icon: Info,
  },
};

const Toast = ({ message, type = "success", darkMode = true }) => {
  const { ring, dot, Icon } = config[type] || config.success;

  return (
    <motion.div
      layout
      initial={{ opacity: 0, x: 40, scale: 0.96 }}
      animate={{ opacity: 1, x: 0, scale: 1 }}
      exit={{ opacity: 0, x: 40, scale: 0.96 }}
      transition={{ type: "spring", stiffness: 380, damping: 30 }}
      className={`relative min-w-[280px] max-w-md flex items-center gap-3 px-4 py-3 rounded-2xl overflow-hidden ${darkMode ? "glass-sheen glass-strong shadow-e2" : "bg-white border border-slate-200 shadow-xl"}`}
    >
      {/* accent rail */}
      <span className={`absolute left-0 top-0 bottom-0 w-1 ${dot}`} />
      <Icon className={`w-5 h-5 shrink-0 ${ring}`} />
      <span className={`text-sm font-medium ${darkMode ? "text-slate-100" : "text-slate-800"}`}>{message}</span>
    </motion.div>
  );
};

export default Toast;
